module.exports = __webpack_public_path__ + "img/cg.ad05b81c.png";